import { useAtomValue } from "jotai";
import { questionnaireGroupsAtom } from "../state/questionnaireGroupsAtom";
import type { Groups } from "../types";

/**
 * Get question groups configuration.
 *
 * @example const groups = useGroups();
 */
export function useGroups(): Groups {
  return useAtomValue(questionnaireGroupsAtom);
}
